const SliderItem = ({
  activeSlide,
  data,
  handleRevertedCard,
  index,
  revertCard,
}) => {
  return (
    <div className="">
      <div
        className={`relative w-[303px] transition-[height]   h- duration-1000 ease-in-out perspective-1000 ${
          activeSlide === index && revertCard
            ? "flipped back-height"
            : "front-height "
        }`}
        onClick={() => handleRevertedCard()}
      >
        <img
          alt="Front of Card"
          className="transform-rotate-0 card front  !left-0"
          src={data?.infos?.find((el) => el.label === "front_url")?.value}
        />
        <img
          alt="Back of Card"
          className="transform-rotate-180 card back ml-10  !left-0"
          src={data?.infos?.find((el) => el.label === "back_url")?.value}
        />
      </div>
      <p className="relative top-32 mb-1  body-16px-demibold text-gray-4 text-center ">
        {data?.infos?.find((el) => el.label === "color_name")?.value}
      </p>
    </div>
  );
};
export default SliderItem;
